/**
 * Cadence rule for live loops that have BOTH a WebSocket push and a REST timer.
 *
 * Only Live Performance has a push channel here (`events_aggregate_ready`); Live Maneuvers is pure
 * REST polling, so this rule has exactly one consumer — `livePerformanceStreamBridge`.
 *
 * Graded maneuvers and BIN 10 aggregates land in PostgreSQL from async Python jobs, so the telemetry
 * WebSocket cannot carry them — the server sends a small "go look" frame instead. Once those frames
 * are arriving the REST timer is pure backstop and should get out of the way; until then it is the
 * only way the page learns anything and must run at full cadence.
 *
 * The condition is "a frame has actually arrived", never "the socket is open". An open socket only
 * proves the transport is up. A connected-but-silent socket — which is exactly what a server that
 * never calls its broadcast looks like — would otherwise leave the page throttled and stale, with
 * nothing on screen to indicate why.
 */

/**
 * Backstop cadence once push is proven. Generous on purpose: at this point the timer only exists to
 * recover frames dropped or emitted before the socket was open, and every tick costs a REST round
 * trip on a page that may be showing several boats.
 */
export const LIVE_PUSH_BACKSTOP_MS = 30_000;
